// eslint-disable-next-line import/no-cycle
import api, {
  unsecuredApi, companySuggestApi, SPMApi, unsecuredSPMApi,
} from '@/services/api';

import { roles } from '@/constants/roles';
import { requestStatuses } from '@/constants/requests';
import { getSortParams } from '@/utils/repositoryUtils';

export function getAmountOfRunningProjects() {
  return api.get('/project/running');
}

export function getSubdomainForTld(tld) {
  return api.get(`/last-scan-data/subdomains-for-tld/${tld}`);
}
export function getEmailsForTld(tld) {
  return api.get(`/last-scan-data/emails-for-tld/${tld}`);
}
export function getHostsForSubdomain(tld, subdoamin) {
  return api.get(`/last-scan-data/hosts-for-subdomains/${tld}/${subdoamin}`);
}
export function createCTCNode(payload) {
  return api.post('/last-scan-data/create-ctc-node', payload);
}
export function getNotifications() {
  return api.get('/notification');
}

export function getNotificationsForSP() {
  return SPMApi.get('/notification');
}

export function updateNotificationStatus(payload) {
  return api.patch('/notification', payload);
}

export function updateNotificationStatusForSP(payload) {
  return SPMApi.patch('/notification', payload);
}

export function deleteNotification(notificationId) {
  return api.delete(`/notification/${notificationId}`);
}

export function deleteNotificationForSP(notificationId) {
  return SPMApi.delete(`/notification/${notificationId}`);
}

export function initiatePasswordSprayScan(payload) {
  return api.post('/project/password-spray', payload);
}
export function editServiceProviderProfileByAdmin(payload) {
  return SPMApi.post('user/company/employees', payload);
}
export function changeServiceProviderEmployeeActiveStatus(employeeId) {
  return SPMApi.put(`/user/company/employees/active/${employeeId}`);
}
export function createNewSPWorker(payload) {
  return SPMApi.post('/user/register/service-provider-worker', payload);
}

export function loadServiceProviderEmployeeAllData(employeeId) {
  return SPMApi.get(`user/company/employees/${employeeId}`);
}

export function deleteServiceProviderEmployee(employeeId) {
  return SPMApi.delete(`user/company/employees/${employeeId}`);
}

export function loadServiceProvidersOfCompany() {
  return SPMApi.get('/user/company/employees');
}

export function loadCompanyCustomerFullRegionsOptions() {
  return api.get('regions/full-options');
}

export function loadCompanyCustomerFullIndustriesOptions() {
  return api.get('industries/full-options');
}

export function loadCompanyCustomerFullRegulationsOptions() {
  return api.get('regulations/full-options');
}

export function loadServiceProviderCompanyFullRegionsOptions() {
  return SPMApi.get('/regions/full-options');
}

export function loadServiceProviderCompanyFullServicesOptions() {
  return SPMApi.get('/company-service/full-options');
}

export function loadServiceProviderFreelancerProfile() {
  return SPMApi.get('/profile/freelancer');
}

export function updateServiceProviderFreelancerProfile(updates) {
  return SPMApi.post('/profile/freelancer', updates);
}

export function updateServiceProviderCompanyProfile(updates) {
  return SPMApi.post('/profile/company', updates);
}

export function loadServiceProviderCompanyProfile() {
  return SPMApi.get('/profile/company');
}

export function updateServiceProviderWorkerProfile(updates) {
  return SPMApi.post('/profile/worker', updates);
}

export function loadServiceProviderWorkerProfile() {
  return SPMApi.get('/profile/worker');
}

export function loadCustomerProfileDetails() {
  return api.get('/profile/user');
}

export function loadCompanyCustomerProfileDetails() {
  return api.get('/profile/company');
}

export function updateCustomerProfile(updates) {
  return api.post('/profile/user', updates);
}

export function updateCompanyCustomerProfile(updates) {
  return api.post('/profile/company', updates);
}

export function loadRegionsForSP() {
  return unsecuredSPMApi.get('/regions');
}

export function loadEmployeesAmountForSP() {
  return unsecuredSPMApi.get('/company/employees-amount-options-data');
}

export function registerSPUser(registrationPayload) {
  return unsecuredSPMApi.post('user/register/freelancer', registrationPayload);
}

export function registerSPCompany(registrationPayload) {
  return unsecuredSPMApi.post('user/register/service-provider-company', registrationPayload);
}

export function loadCertificates() {
  const params = {};
  params.isCompany = false;
  return unsecuredSPMApi.get('/certificate', { params });
}

export function loadCertificatesForCompanySP() {
  const params = {};
  params.isCompany = true;
  return unsecuredSPMApi.get('/certificate', { params });
}

export function loadServicesForCompanySP() {
  return unsecuredSPMApi.get('/company-service');
}

export function loadServices() {
  return unsecuredSPMApi.get('/worker-service');
}

export function loadTestTypes() {
  return api.get('/project/test-types');
}

export function loadProfile() {
  return api.post('/profile');
}

export function loadSPProfile() {
  return SPMApi.get('/profile');
}

export function loadPermissions() {
  return api.post('/permission');
}

export function loadPermissionsForSP() {
  return SPMApi.get('/permission');
}

export function requestEmailVerification(userPoolId) {
  return api.post('/user/request-email-verification', { userPoolId });
}

export function requestEmailVerificationForSP() {
  return SPMApi.post('/user/request-email-verification', process.env.VUE_APP_AMPLIFY_COGNITO_USER_POOL_ID);
}

export function verifyEmailForSP(code) {
  return SPMApi.post('/user/verify-email', { code });
}

export function verifyEmail(code, userPoolId) {
  return api.post('/user/verify-email', { userPoolId, code });
}

export function loadCompanySuggest(query) {
  return companySuggestApi.get('/companies/suggest', { params: { query } });
}

export function registerUser(userData) {
  return unsecuredApi.post('/user/register', userData);
}

export function loadRegulations() {
  return unsecuredApi.get('/regulations');
}

export function loadIndustries() {
  return unsecuredApi.get('/industries');
}

export function loadCybersecurityKnowhowOptions() {
  return unsecuredApi.get('/user/cybersecurity-knowhow-options');
}

export function loadAmountOfEmployees() {
  return unsecuredApi.get('/company/employees-amount-options-data');
}

export function loadRegions() {
  return unsecuredApi.get('/regions');
}

export function loadProjects({
  sort, limit, page, search, refId,
} = {}, payload = null) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.page = page;
  params.search = search;
  if (refId) {
    params.refId = refId;
  }
  return api.post('/project/list', payload, { params });
}

export function loadCentralizedIssues({
  sort, limit, page, toggles, search, refId,
} = {}, payload = null) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.page = page;
  params.specificSearch = toggles.specificSearch;
  params.hideSuppress = toggles.hideSuppress;
  params.hideFixed = toggles.hideFixed;
  params.onlyCVEs = toggles.onlyCVEs;
  params.search = search;
  if (refId) {
    params.refId = refId;
  }
  return api.post('/issues/list', payload, { params });
}

export function loadHighlightReports({
  sort, limit, page, search, domain, timeRange,
} = {}) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.page = page;
  params.search = search;
  params.domain = domain;
  params.timeRange = timeRange;
  return api.get('/reports/highlight', { params });
}

export function generateReport(payload) {
  return api.post('/reports/generate', payload);
}

export function loadIntegrations({
  sort, limit, page, search,
} = {}) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.page = page;
  params.search = search;
  return api.get('/integrations', { params });
}

export function deleteIntegration(payload) {
  const { integrationId } = payload;
  return api.delete(`/integrations/${integrationId}`);
}

export function listIntegrationsByCategory(payload) {
  return api.post('/integrations/list-category', payload);
}

export function loadIntegrationOptionsList() {
  return api.get('/integrations/list');
}

export function loadIntegrationDetails(payload) {
  return api.post('/integrations/details', payload);
}

export function saveNewIntegration(payload) {
  return api.post('/integrations', payload);
}

export function testIntegration(payload) {
  return api.post('/integrations/test', payload);
}

export function runIntegration(payload) {
  return api.post('/integrations/execute', payload);
}

export function loadProjectsForSP({ sort, limit } = {}) {
  const params = getSortParams(sort);
  params.limit = limit;

  return SPMApi.get('/project', { params });
}

export function loadDetailedProject(id) {
  return api.get(`/project/${id}`);
}

export function loadDetailedProjectForSP(id) {
  return SPMApi.get(`/project/${id}`);
}

export function loadRequests({ sort, limit } = {}) {
  const params = getSortParams(sort);
  params.limit = limit;

  return SPMApi.get('/project-requests', { params });
}

export function loadUsers({ sort, limit } = {}) {
  const params = getSortParams(sort);
  params.limit = limit;

  params.roles = roles.CUSTOMER_MANAGER;

  return api.get('/user', { params });
}

export function deleteUser(payload) {
  const { userId } = payload;
  return api.delete(`/user/${userId}`);
}

export function deletePendingUser(payload) {
  const { pendingUserId } = payload;
  return api.delete(`/user/pending/${pendingUserId}`);
}

export function saveEditedUser(payload) {
  return api.post('/user/edit-user', payload);
}

export function resetUserPassword(payload) {
  return api.post('/user/reset-password', payload);
}
export function changeRequestStatus(id, status) {
  if (status === requestStatuses.ACCEPTED) {
    return SPMApi.post(`/project-requests/${id}/accept`);
  }
  if (status === requestStatuses.DECLINED) {
    return SPMApi.post(`/project-requests/${id}/decline`);
  }
  return Promise.reject();
}

export function loadAvailableWorkers({ sort, limit } = {}, options) {
  const params = getSortParams(sort);
  params.limit = limit;

  params.startDate = options.startDate;
  params.endDate = options.endDate;

  return api.get('/user/available-workers', { params });
}

export function addNewProject(newProject) {
  return api.post('/project', newProject);
}

export function updateServiceProviderInfo(projectId, data) {
  return api.patch(`/project/${projectId}/service-provider`, data);
}

export function loadWorkerDetails(id) {
  return api.get(`user/workers/${id}`);
}

export function updateProjectCredentials(projectId, credentials) {
  return api.put(`/project/${projectId}/credentials`, { credentials });
}

export function loadIssuesBySP({ sort, limit } = {}, options) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.projectId = options.projectId;

  return SPMApi.get('/issues', { params });
}

export function loadIssues({ sort, limit } = {}, options) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.projectId = options.projectId;

  return api.get('/issues', { params });
}

export function loadIssuesInnerDataForSP() {
  return SPMApi.get('issues/inner-data');
}

export function loadIssuesInnerData() {
  return api.get('issues/inner-data');
}

export function addNewIssueBySP(newIssue) {
  return SPMApi.post('/issues', newIssue);
}

export function addNewIssue(newIssue) {
  return api.post('/issues', newIssue);
}

export function changeIssueStatus(issueId, status) {
  return api.patch(`/issues/${issueId}`, { status });
}

export function changeIssueSuppressStatus(payload) {
  return api.patch('/issues/toggle-suppress', payload);
}
export function downloadIssuesCSVReport(payload) {
  return api.post('/issues/download-csv', payload);
}

export function changeIssueStatusBySP(issueId, status) {
  return SPMApi.patch(`/issues/${issueId}`, { status });
}

export function getIssueDetails(issueId) {
  return api.get(`/issues/${issueId}`);
}

export function getIssueDetailsForSP(issueId) {
  return SPMApi.get(`/issues/${issueId}`);
}

export function deleteIssueBySP(issueId) {
  return SPMApi.delete(`/issues/${issueId}`);
}

export function editIssueBySP(issueId, issue) {
  return SPMApi.patch(`/issues/${issueId}/details`, issue);
}

export function updateProjectTasksBySP(projectId, tasks) {
  return SPMApi.patch(`/project/${projectId}/tasks`, { tasks });
}

export function startKrakenPassiveScan(userDomain) {
  return unsecuredApi.post('/kraken', userDomain);
}

export function startTestScan(payload) {
  return api.post('/kraken/initiate-scan-test', payload);
}

export function initiateProjectAutomatedScoping(payload) {
  return api.post('/project/analyze/web-app', payload);
}

export function initiateWebProjectEstimation(payload) {
  return api.post('/project/calculate/web-app', payload);
}

export function updateProjectStatusBySP(projectId, status) {
  return SPMApi.patch(`/project/${projectId}/status`, { status });
}

export function loadDomains(id) {
  return api.get(`/company/${id}`);
}

export function loadLicensing() {
  return api.get('/licensing');
}

export function activateLicense(payload) {
  return api.post('/licensing/activate', payload);
}

export function activateOrgLicense(orgId, payload) {
  return api.post(`/licensing/activate/${orgId}`, payload);
}

export function getAllTenantUsers() {
  return api.get('/tenant-managment/all-users');
}

export function tenantAdminChangeUserRole(id, payload) {
  return api.post(`/permission/${id}/change-role`, payload);
}

export function getAllPendingUsers() {
  return api.get('/tenant-managment/pending-users');
}

export function findUserPoolId(domain) {
  return unsecuredApi.post('iam', domain);
}

export function findUserPoolClientId(options) {
  return unsecuredApi.post('iam/client', options);
}

export function deleteUserPoolId(userPoolId) {
  return unsecuredApi.post('iam/delete', userPoolId);
}

export function inviteNewUsers(data) {
  return api.post('tenant-managment/invite-users', data);
}

export function updateSystemSettings(data) {
  return api.post('tenant-managment/system-settings', data);
}

export function getSystemSettings() {
  return api.get('tenant-managment/system-settings');
}

export function addNewTestProject(payload) {
  return api.post('project/test-card', payload);
}

export function loadTestCards(type, payload = {}) {
  const params = {};
  params.type = type;
  if (payload?.domain) {
    params.domain = payload.domain;
  }
  if (payload?.onlyRepetitive) {
    params.onlyRepetitive = payload.onlyRepetitive;
  }
  if (payload?.subdomains) {
    params.subdomains = payload.subdomains;
  }
  if (payload?.hosts) {
    params.hosts = payload.hosts;
  }
  return api.get('project/test-card', { params });
}

export function removeTestCard(testCardId) {
  return api.delete(`project/test-card/${testCardId}`);
}

export function calculateLastScanData(filters) {
  return api.post('last-scan-data', filters);
}

export function loadPanoramicData(filters) {
  return api.post('last-scan-data/panoramic-data', filters);
}

export function getPortsToScore(filters) {
  const params = {};
  params.filters = filters;
  return api.get('last-scan-data/ports-to-score', { params });
}

export function calculateDashboardStatistics(filters) {
  return api.post('stats', filters);
}

export function calculateProjectsStatistics(filters) {
  return api.post('stats/project', filters);
}

export function calculateCloudServicesStatistics(filters) {
  return api.post('stats/cloud-compliance', filters);
}

export function initiateTestCard(testCardIds) {
  return api.post('project/test-card/initiate', testCardIds);
}

export function addNewConfiguration(payload) {
  return api.put('manual-configuration', payload);
}

export function loadCloudAssetsFromConfiguration() {
  return api.get('manual-configuration/cloud-assets');
}

export function loadBucketAssetsFromConfiguration() {
  return api.get('manual-configuration/bucket-assets');
}

export function loadOrganizationTagsConfiguration() {
  return api.get('manual-configuration/organization-tags');
}

export function createOrUpdateOrganization(payload) {
  return api.post('company/organization', payload);
}

export function getAllOrganizations() {
  return api.get('company/organization');
}

export function deleteOrganization(id) {
  return api.delete(`company/organization/${id}`);
}

export function setDefaultOrganization(payload) {
  return api.put('company/default-domain', payload);
}
export function loadServicesAssetsFromConfiguration({
  sort, limit, page, search, domain, complianceItems, regions, refId,
} = {}) {
  const params = getSortParams(sort);
  params.limit = limit;
  params.page = page;
  params.search = search;
  const payload = {
    domain, complianceItems, regions,
  };
  if (refId) {
    params.refId = refId;
  }
  return api.post('cloud-compliance', payload, { params });
}

export function loadRowLevelCloudItem(payload) {
  return api.post(`cloud-compliance/${payload.layer}`, payload);
}

export function initiateHijackedActionAsset(payload) {
  return api.post('project/protect', payload);
}

export function initiateWafActionAsset(payload) {
  return api.post('project/waf/protect', payload);
}

export function loadInventoryDataByTab(payload) {
  let params = {};
  const body = {};

  params = getSortParams(payload.sort);
  if (!params.sort) {
    params.sort = {};
  }
  params.limit = payload.limit;
  params.page = payload.page;
  params.search = payload.search;
  params.toggles = payload.toggles;
  params.tab = payload.tab;
  if (payload?.filter) {
    if (payload.tab === 'leaks') {
      params.filter = payload.filter;
    } else {
      params.filter = JSON.stringify(Object.fromEntries(payload.filter));
    }
  }
  if (payload?.refId) {
    params.refId = payload.refId;
  }
  if (payload?.filters) {
    params.filters = JSON.stringify(payload.filters);
  }
  if (payload?.selectAllFilters) {
    params.selectAllFilters = payload.selectAllFilters;
    if (payload?.selectAllFilters?.filter) {
      if (Array.isArray(payload.selectAllFilters.filter)) {
        params.selectAllFilters.filter = JSON.stringify(Object.fromEntries(payload.selectAllFilters.filter));
      } else {
        params.selectAllFilters.filter = JSON.stringify(payload.selectAllFilters.filter);
      }
    }
  }

  body.domain = payload.domain;
  body.organizations = payload.organizations;

  return api.post('last-scan-data/paginated-items-by-tab', body, { params });
}

export function clearInfostealersCache() {
  return api.post('last-scan-data/clear-infostealers-cache');
}

export function getInfostealersProgress() {
  return api.get('/last-scan-data/infostealers-progress');
}

export function loadPasswordSprayStatsUpdated(payload) {
  return api.post('last-scan-data/password-spray-stats-updated-indication', payload);
}

export function downloadCSVReportByTab(payload) {
  let params = {};
  const body = {};

  params = getSortParams(payload.sort);
  if (!params.sort) {
    params.sort = {};
  }
  params.search = payload.search;
  params.toggles = payload.toggles;
  if (payload?.filter) {
    if (payload.tab === 'leaks') {
      params.filter = payload.filter;
    } else {
      params.filter = JSON.stringify(Object.fromEntries(payload.filter));
    }
  }
  params.tab = payload.tab;

  body.domain = payload.domain;
  body.organizations = payload.organizations;

  return api.post('/last-scan-data/download-csv-by-tab', body, { params });
}

export function loadDomainsConfiguration() {
  return api.get('manual-configuration/domains');
}

export function loadCloudAccountsConfiguration(
  {
    noLimit, sort, limit, page, search, organizations,
  },
) {
  const params = getSortParams(sort);
  params.noLimit = noLimit;
  params.limit = limit;
  params.page = page;
  params.search = search;
  params.organizations = organizations;
  return api.get('manual-configuration/accounts', { params });
}

export function loadSubdomainTagsConfiguration() {
  return api.get('manual-configuration/subdomain-tags');
}

export function loadDomainTagsConfiguration() {
  return api.get('manual-configuration/domain-tags');
}

export function loadCloudAccountsTags() {
  return api.get('manual-configuration/cloud-account-tags');
}

export function loadSubdomainsFromConfiguration() {
  return api.get('manual-configuration/subdomains');
}

export function loadHostsFromConfiguration() {
  return api.get('manual-configuration/hosts');
}

export function loadCredentialsFromConfiguration() {
  return api.get('manual-configuration/credentials');
}

export function getWafManualConfiguration(payload) {
  return api.post('manual-configuration/waf', payload);
}

export function getCompanyInfo(domain) {
  return unsecuredApi.post('company', domain);
}

export function downloadScanDataReport(payload) {
  return api.post('project/download-report', payload);
}

export function downloadIssuesCSV(id) {
  return api.get(`project/issues-csv-file/${id}`);
}

export function getPassiveRiskScore(tlds) {
  return api.post('risk-score/passive', tlds);
}
export function getPassiveRiskScoreHistory(tlds) {
  return api.post('risk-score/history', tlds);
}
export function createWorkflow(workflowPayload) {
  return api.post('workflows', workflowPayload);
}

export function updateWorkflow(workflowPayload) {
  return api.patch('workflows', workflowPayload);
}

export function loadWorkflows() {
  return api.get('workflows');
}

export function validateTld(payload) {
  return api.post('manual-configuration/validate', payload);
}

export function updateSensitivity(payload) {
  return api.post('manual-configuration/sensitivity', payload);
}

export function deleteConfiguration(payload) {
  return api.post('manual-configuration/delete', payload);
}

export function findIdentityId(payload) {
  return unsecuredApi.post('iam/identity', payload);
}

export function stopScan(id) {
  return api.post(`project/stop/${id}`);
}

export function retryScan(projectId) {
  return api.post(`project/retry/${projectId}`);
}

export function loadActivities(payload) {
  const params = {};
  if (payload?.type) {
    params.type = payload.type;
  }
  return api.get('activity', { params });
}

export function loadActivityData(activityId) {
  return api.get(`/activity/${activityId}`);
}

export function updateActivity(activityId, updates) {
  return api.patch(`/activity/${activityId}`, { updates });
}

export function loadApiKeys() {
  return api.get('api-keys');
}

export function addApiKey(apiKeyPayload) {
  return api.post('api-keys', apiKeyPayload);
}

export function deleteApiKey(payload) {
  const { apiKeyId } = payload;
  return api.delete(`api-keys/${apiKeyId}`);
}

export function validateInvitationCode(code, recaptchaToken) {
  return unsecuredApi.post('/user/verify-invitation-code', { code, recaptchaToken });
}

export function getUserLoginOptions(email) {
  return unsecuredApi.post('/auth/login-options', { email });
}

export function initiateOtpLogin(email, domain) {
  return unsecuredApi.post('/auth/initiate-otp', { email, domain });
}

export function verifyOtpLogin(code, session, email, domain, username) {
  return unsecuredApi.post('/auth/verify-otp', {
    code, session, email, domain, username: username || email,
  });
}

export function getInsightsDetails(tlds) {
  return api.post('insights', tlds);
}

export function recalculateRiskScore(payload) {
  return api.post('risk-score/recalculate', payload);
}
